module.exports = __webpack_public_path__ + "rookout.bde380.svg";